<template>
  <div
    ref="dynamic_head"
    class="dynamic-detail-one"
    :class="!moveComment && 'hover-visible'"
    @click="$emit('opendetail', info)"
  >
    <FeedTool
      v-if="info.userUuid !== adminUuid"
      class="feed-tool"
      :operateUuid="info.userUuid"
      :masterUuid="info.userUuid"
      @clickdelete="deleteDynamic"
    />
    <div class="dynamic-detail-title">
      <fps-avatar
        class="user-avatar"
        :src="info.avatarUrl"
        :dressup="info.avatarFrame"
        :level="info.userLevel"
        :style="{ transform: `scale(${info.userLevel > 5 ? 0.8 : 1})` }"
        @click.native.stop="openDetail(info)"
      />
      <div class="text-wrap">
        <div class="nickname">
          <span>{{ info.nickname }}</span>
          <fps-icon
            v-if="info.userUuid == adminUuid"
            type="v-mark"
            class="is-admin"
            size="18"
            color="#FFA24E"
          />
          <div
            v-else
            class="userlevel-tag level-mg"
            :class="`level-${info.userLevel}`"
          ></div>
        </div>
        <span class="create-time">{{ timeToMin(info.createTime) }}</span>
      </div>
    </div>
    <div v-if="dynamicText && filterIframe(dynamicText)" class="content-wrap">
      <div v-html="filterIframe(dynamicText)" class="text-content" />
    </div>
    <div v-if="liveSrc" v-html="liveSrc" class="live-video"></div>
    <div v-if="info.content.videoContent" class="video-wrap">
      <FpsVideo
        :class="videoWidth"
        :longWidth="
          +info.content.videoContent.width >= +info.content.videoContent.height
        "
        :src="info.content.videoContent.videoUrl"
        position="cover"
        @click.native.stop
      />
    </div>
    <div v-else-if="info.content.imageContent" class="image-wrap">
      <template v-if="info.content.imageContent.imageUrlList.length > 1">
        <div
          v-for="(list, i) in imgGroup"
          :key="'imagelist-' + i"
          class="img-list"
        >
          <fps-scale-img
            v-for="(url, j) in list"
            :key="'img-' + j"
            class="one-img"
            :src="url + '?d=300x300'"
            :imageList="info.content.imageContent.imageUrlList"
            :defaultIndex="i * 3 + j"
            position="center center"
            borderRadius="12px"
            @click.native.stop
          />
        </div>
      </template>
      <template v-else>
        <div
          v-if="originSize"
          class="origin-image"
          :class="originSize"
          :style="{
            backgroundImage: `url(${info.content.imageContent.imageUrlList[0]})`
          }"
          @click.stop="showScaleImage"
        />
        <div v-else class="origin-image">
          <img
            class="origin-img"
            :src="info.content.imageContent.imageUrlList[0]"
            @click.stop="showScaleImage"
          />
        </div>
        <fps-scale-img
          v-show="false"
          ref="origin_image"
          :src="info.content.imageContent.imageUrlList[0]"
          :imageList="info.content.imageContent.imageUrlList"
          @click.native.stop
        />
      </template>
    </div>
    <div v-if="info.content.skillContent" class="skill-wrap">
      <button @click.stop="openSkillDetail">
        <!-- <img class="game-logo" :src="info.content.skillContent.skill.gameLogo" > -->
        <span class="skill-name">{{
          info.content.skillContent.skill.gameName
        }}</span>
        <span class="skill-price"
          >{{$t('upgrade_page_views_master_components_skill_info_base_info_253', [ info.content.skillContent.skill.salesPrice ,
            info.content.skillContent.skill.salesUnit | salesUnitTranslate
          ])}}</span
        >
      </button>
    </div>
    <div class="dynamic-feel">
      <div class="white-commnet pointer" @click.stop="toWriteComment">
        <fps-icon class="edit-icon" type="edit2" size="18" />
        <span v-if="info.commentCount">{{$t('upgrade_page_views_user_feed_feed_detail_1420')}}</span>
        <span v-else>{{$t('upgrade_page_views_user_feed_feed_detail_1421')}}</span>
      </div>
      <div class="like-container">
        <Like
          v-model="info.isLike"
          :momentId="info.id"
          class="like-wrap"
          size="18"
          @change="likeChange"
        />
        <span>{{$t('components_order_order_card_543')}}</span>
      </div>
    </div>
    <div v-if="showWriteComment" class="write-comment-wrap">
      <div class="write-comment" @click.stop="commentWriteFocus">
        <textarea
          v-model="commnetText"
          ref="comment_write"
          class="comment-area"
          :maxlength="maxlength"
          rows="3"
          @click.stop
        />
        <span class="write-count"
          >{{ commnetText.length }}/{{ maxlength }}</span
        >
      </div>
      <div class="comment-btns">
        <button class="cancel-comment" @click.stop="showWriteComment = false">{{$t('upgrade_page_layout_header_42')}}</button>
        <button class="confirm-comment" @click.stop="submitComment">
          <i v-if="submitingComment" class="el-icon-loading"></i>
          <span v-else>{{$t('components_order_order_card_525')}}</span>
        </button>
      </div>
    </div>
    <template v-if="info.commentCount || info.likeCount">
      <div class="line" />
      <div class="count-wrap">
        <div v-if="info.likeCount" class="like-count">{{$t('upgrade_page_views_user_feed_feed_detail_1422', [ info.likeCount ])}}</div>
        <div v-if="info.commentCount" class="moment-count">{{$t('upgrade_page_views_user_feed_feed_detail_1423', [ info.commentCount ])}}</div>
      </div>
    </template>
    <template v-if="info.commentCount">
      <div @mouseenter="moveComment = true" @mouseleave="moveComment = false">
        <div
          v-show="info.commentCount > 2 && showAllComment"
          class="comment-list"
        >
          <CommentItem
            v-for="(c, i) in info.commentList"
            :key="'comment-' + c.id"
            :comment="c"
            :masterUuid="info.userUuid"
            @replycomment="replyComment($event, i)"
            @deletereply="deleteReply(i, $event)"
            @updatereply="updateReply($event, i)"
            @deletecomment="deleteComment(i)"
            @click.native.stop
          />
        </div>
        <div v-show="!showAllComment" class="comment-list">
          <CommentItem
            v-for="(c, i) in (info.commentList || []).slice(0, 2)"
            :key="'comment-' + c.id"
            :comment="c"
            :masterUuid="info.userUuid"
            @replycomment="replyComment($event, i)"
            @deletereply="deleteReply($event, i)"
            @updatereply="updateReply($event, i)"
            @click.native.stop
            @deletecomment="deleteComment(i)"
          />
        </div>
        <button
          v-if="info.commentCount > 2 && !gettingCommentList"
          class="show-all-comment"
          @click.stop="$emit('opendetail', info)"
        >
          {{
            showAllComment ? $t('upgrade_page_views_user_feed_feed_list_item_1427') : $t('upgrade_page_views_user_feed_feed_list_item_1428',[info.commentCount])
          }}
        </button>
        <div v-if="gettingCommentList" class="loading-wrap">
          <i class="el-icon-loading" />
        </div>
      </div>
    </template>
    <SkillDetail
      v-if="info.content && info.content.skillContent"
      v-model="showSkillDetail"
      :info="skillInfo"
    />
  </div>
</template>
<script>
import i18n from '@/locales/index'
import { writeMomentComment, deleteDynamic, getCommentList } from './moment';
import { mapGetters } from 'vuex';

import Like from './Like';
import CommentItem from './comment-item';
import SkillDetail from '@/components/SkillDetail';
import FeedTool from './feed-tool';
import FpsVideo from '@/components/FpsVideo';

export default {
  components: {
    Like,
    CommentItem,
    SkillDetail,
    FeedTool,
    FpsVideo
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    isSquare: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoading: false,
      showWriteComment: false,
      commnetText: '',
      maxlength: 140,
      submitingComment: false,
      showSkillDetail: false,
      skillInfo: {},
      showAllComment: false,
      moveComment: false,
      gettingCommentList: false
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'viewMasterInfo', 'adminUuid']),
    imgGroup() {
      const list = [];
      if (this.info.content.imageContent) {
        const { imageUrlList } = this.info.content.imageContent;
        if (imageUrlList.length === 4) {
          list.push(imageUrlList.slice(0, 2));
          list.push(imageUrlList.slice(2, 4));
        } else {
          let start = 0;
          const step = 3;
          while (start + step < imageUrlList.length) {
            list.push(imageUrlList.slice(start, start + step));
            start += step;
          }
          list.push(imageUrlList.slice(start, imageUrlList.length));
        }
      }
      return list;
    },
    originSize() {
      if (
        !this.info.content.imageContent ||
        this.info.content.imageContent.imageUrlList.length !== 1
      )
        return '';
      const image = this.info.content.imageContent.imageUrlList[0];
      const rs = image.match(/\/(\d+)x(\d+)_/);
      if (!rs) return '';
      const sub = rs[1] / rs[2];
      if (sub > 1.166) {
        return 'is-width';
      } else if (sub < 0.875) {
        return 'is-height';
      }
      return '';
    },
    videoWidth() {
      if (!this.info.content.videoContent) return '';
      const { width, height } = this.info.content.videoContent;
      if (!width || !height) return 'square-video';
      const sub = width / height;
      if (sub > 1.166) {
        return 'width-video';
      } else if (sub < 0.875) {
        return 'height-video';
      }
      return 'square-video';
    },
    dynamicText() {
      let text = '';
      let tag = '';
      if (this.info.content.textContent)
        text =
          this.info.content.textContent.text.replace(/\n/g, '<br>') + '&nbsp;';
      if (this.info.tag)
        tag = `<span style="color: #FE7538;font-weight: normal;">#${this.info.tag}</span>`;
      return text + tag;
    },
    // 直播链接
    liveSrc() {
      return this.dynamicText ? this.getLiveSrc(this.dynamicText) : null;
    }
  },
  methods: {
    openDetail(info) {
      this.$util.openWindow(`/player-detail/${info.userUuid}`);
    },
    showScaleImage() {
      if (this.$refs.origin_image)
        this.$refs.origin_image.showFullScreenImage = true;
    },
    deleteComment(i) {
      this.info.commentList.splice(i, 1);
      this.info.commentCount--;
      this.$emit('updatedynamic', this.info);
    },
    deleteDynamic() {
      if (this.deleting) return;
      this.deleting = true;
      deleteDynamic({
        momentId: this.info.id
      })
        .then(() => {
          this.$emit('deletedynamic');
          this.deleting = false;
        })
        .catch(() => {
          this.deleting = false;
        });
    },
    async clickShowComment() {
      if (this.gettingCommentList) return;
      if (this.info.commentList && this.info.commentList.length === 2) {
        this.gettingCommentList = true;
        try {
          const { data } = await getCommentList({
            momentId: this.info.id,
            size: 50,
            needReply: false
          });
          this.info.commentList = data;
          data.forEach(item => {
            delete item.replyList;
            delete item.replyCount;
          });
          this.$emit('updatedynamic', this.info);
          this.gettingCommentList = false;
        } catch (e) {
          console.log(e);
          this.gettingCommentList = false;
          return;
        }
      }
      this.showAllComment = !this.showAllComment;
      if (!this.showAllComment) {
        this.$nextTick(() => {
          this.$refs.dynamic_head.scrollIntoView({
            behavior: 'smooth'
          });
        });
      }
    },
    deleteReply({ index }, i) {
      const comment = this.info.commentList[i];
      comment.replyList.splice(index, 1);
      comment.replyCount--;
      this.$emit('updatedynamic', this.info);
    },
    updateReply(list, i) {
      this.info.commentList[i].replyList = list;
      this.$emit('updatedynamic', this.info);
    },
    openSkillDetail() {
      this.skillInfo = {
        ...this.info.content.skillContent.skill,
        uuid: this.info.userUuid
      };
      this.showSkillDetail = true;

      this.isSquare &&
        this.$adjust('web_moment_list_skill', {
          moment_uuid: this.info.userUuid,
          skill_id: this.info.content.skillContent.skill.id
        });
    },
    replyComment(data, i) {
      const comment = this.info.commentList[i];
      comment.replyCount = (comment.replyCount || 0) + 1;
      if (!comment.replyList) comment.replyList = [];
      comment.replyList.push(data);
      this.info.commentList.splice(i, 1, comment);
      this.$emit('updatedynamic', this.info);
    },
    submitComment() {
      const {
        commnetText,
        info: { id: momentId }
      } = this;
      if (this.submitingComment || !commnetText) return;
      this.submitingComment = true;
      writeMomentComment({
        content: commnetText,
        momentId
      })
        .then(({ data }) => {
          this.submitingComment = false;
          this.commnetText = '';
          this.showWriteComment = false;
          this.$message.success(i18n.t('components_order_order_card_564'));
          if (!this.info.commentList) this.info.commentList = [];
          this.info.commentCount = this.info.commentCount + 1;
          this.info.commentList.unshift(data);
          this.$emit('updatedynamic', this.info);
        })
        .catch(() => {
          this.$message.error(i18n.t('upgrade_page_views_settled_in_step_2_1289'));
          this.submitingComment = false;
        });
    },
    toWriteComment() {
      if (!this.userInfo) {
        this.$util.Login().then(() => {
          this.toWriteComment();
        });
        return;
      }
      this.showWriteComment = true;
      this.$nextTick(() => {
        this.commentWriteFocus();
      });
      this.isSquare &&
        this.$adjust('web_moment_list_like', {
          moment_uuid: this.info.userUuid
        });
    },
    commentWriteFocus() {
      const dom = this.$refs.comment_write;
      if (dom) dom.focus();
    },
    timeToMin(time) {
      const d = new Date(time);
      const now = Date.now();
      const createTime = d.getTime();
      // 距离现在几分钟
      let sub = Math.floor((now - createTime) / 60 / 1000);
      if (sub < 5) return i18n.t('upgrade_page_views_user_feed_feed_detail_1424');
      if (sub < 60) return sub + i18n.t('utils_util_1391');
      if (sub < 60 * 24) return Math.floor(sub / 60) + i18n.t('utils_util_1388');
      if (sub < 7 * 60 * 24) return Math.floor(sub / 60 / 24) + i18n.t('utils_util_1389');
      let month = d.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      let date = d.getDate();
      if (date < 10) {
        date = '0' + date;
      }
      return `${d.getFullYear()}-${month}-${date}`;
    },
    likeChange(like) {
      if (like) {
        this.$set(this.info, 'likeCount', this.info.likeCount + 1);
        this.isSquare &&
          this.$adjust('web_moment_list_like', {
            moment_uuid: this.info.userUuid
          });
      } else {
        this.$set(this.info, 'likeCount', this.info.likeCount - 1);
      }
    },
    // 切换轮播
    swipeChange(method, refName) {
      const $swipe = this.$refs[refName];
      if (!$swipe) return;
      $swipe[method]();
    },
    filterIframe(text) {
      const regex = /<iframe.*?<\/iframe>/;
      return text.replace(regex, '');
    },
    getLiveSrc(src) {
      src = src.replace(/(width|height)="[^"]*"/g, '$1="100%"');
      const regex = /<iframe.*?<\/iframe>/;
      const matches = src.match(regex);
      const path = matches && matches.length > 0 ? matches[0] : '';
      if (path.includes('twitch')) {
        return path.replace(
          'www.example.com',
          process.env.VUE_APP_ENV === 'test'
            ? 'test.nicee.tw'
            : 'www.nicee.tw'
        );
      }
      return path;
    }
  }
};
</script>
<style lang="scss" scoped>
.like-wrap {
  position: relative;
  &::after {
    content: '';
    position: absolute;
    left: -13px;
    top: -5px;
    width: 74px;
    height: 28px;
  }
}
.dynamic-detail-one {
  box-sizing: border-box;
  border-radius: 4px;
  padding: 24px;
  padding-left: 90px;
  position: relative;
  .feed-tool {
    position: absolute;
    top: 24px;
    right: 24px;
    transform: scale(0);
  }
  &.hover-visible:hover .feed-tool {
    transform: scale(1);
  }
  .loading-wrap {
    width: 100%;
    @include flex;
    padding: 40px;
    font-size: 24px;
  }
  .dynamic-detail-title {
    margin-bottom: 10px;
    margin-left: -66px;
    @include flex;
    .user-avatar {
      width: 50px;
      height: 50px;
      margin-right: 16px;
      cursor: pointer;
    }
    .text-wrap {
      flex: 1;
      @include flex(center, flex-start, column);
      .nickname {
        @include flex(flex-start);
        height: 22px;
        margin-bottom: 2px;
        span {
          font-weight: 500;
          font-size: 14px;
          color: $color-gray-1;
        }
        .is-admin {
          margin-left: 3px;
        }
        .userlevel-tag {
          margin-left: 8px;
        }
      }
      .create-time {
        font-size: 12px;
        line-height: 16px;
        color: $color-gray-3;
      }
    }
    .reace-btn {
      width: 54px;
      height: 26px;
      line-height: 26px;
      border-radius: 15px;
      border: 1px solid $color-gray-2;
      @include flex;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.3px;
      color: $color-gray-1;
    }
  }
  .video-wrap,
  .image-wrap {
    margin-bottom: 15px;
    .origin-image {
      border-radius: 12px;
      background: no-repeat center center / cover;
      overflow: hidden;
      .origin-img {
        max-width: 400px;
        max-height: 400px;
        border-radius: 12px;
        cursor: zoom-in;
      }
      &.is-width {
        width: 400px;
        height: 300px;
        cursor: zoom-in;
      }
      &.is-height {
        width: 300px;
        height: 400px;
        cursor: zoom-in;
        background-position: center top;
      }
    }
    .width-video {
      width: 400px;
      height: 300px;
      .fps-video-content {
        height: 100%;
      }
    }
    .square-video {
      width: 400px;
      height: 400px;
      .fps-video-content {
        height: 100%;
      }
    }
    .height-video {
      width: 300px;
      height: 400px;
      .fps-video-content {
        width: 100%;
      }
    }
  }
  .img-list {
    @include flex(flex-start);
    &:not(:first-child) {
      margin-top: 8px;
    }
    .one-img {
      width: 184px;
      height: 184px;
      background: #f9f9f9;
      &:not(:first-child) {
        margin-left: 8px;
      }
    }
  }
  .content-wrap {
    margin-bottom: 16px;
    @include flex(flex-start);
    .text-content {
      font-weight: 500;
      font-size: 13px;
      line-height: 18px;
      margin-right: 4px;
      color: $color-gray-1;
    }
  }
  .skill-wrap {
    margin-bottom: 21px;
    button {
      img {
        width: 16px;
        border-radius: 50%;
        margin-right: 8px;
      }
      padding: 4px 16px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      @include flex;
      background: $color-yellow;
      border-radius: 40px;
      .skill-name {
        margin-right: 16px;
      }
    }
  }
  .dynamic-feel {
    @include flex(space-between);
    margin-bottom: 21px;
    .white-commnet {
      @include flex;
      span {
        font-size: 14px;
        line-height: 18px;
        letter-spacing: -0.00032px;
        color: $color-gray-3;
        margin-left: 4px;
      }
    }
    .like-container {
      @include flex;
      span {
        font-size: 14px;
        line-height: 18px;
        letter-spacing: -0.00032px;
        color: $color-gray-3;
        margin-left: 4px;
      }
    }
  }
  .write-comment-wrap {
    margin-bottom: 16px;
    .comment-btns {
      margin-top: 8px;
      @include flex(flex-end);
      button {
        width: 80px;
        height: 32px;
        @include flex;
        font-size: 13px;
        line-height: 18px;
        border-radius: 50px;
      }
      .cancel-comment {
        color: $color-gray-2;
        border: 1px solid $color-split;
        margin-right: 10px;
      }
      .confirm-comment {
        color: $color-gray-1;
        background: $color-yellow;
      }
    }
  }
  .write-comment {
    background: #f9f9f9;
    border: 1px solid $color-split;
    border-radius: 8px;
    padding: 12px 12px 10px;
    @include flex(flex-start, flex-end, column);
    .comment-area {
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-1;
      resize: none;
    }
    .write-count {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: $color-gray-4;
    }
  }
  .line {
    width: 100%;
    height: 1px;
    background: $color-split;
    margin-bottom: 16px;
  }
  .count-wrap {
    @include flex(flex-start);
    font-weight: 500;
    font-size: 12px;
    line-height: 17px;
    color: $color-gray-3;
    .like-count {
      color: $color-gray-1;
      margin-right: 35px;
    }
  }
  .show-all-comment {
    margin-top: 16px;
    font-size: 14px;
    line-height: 20px;
    color: $color-gray-3;
  }
}
.custom-swiper {
  width: 100%;
  margin-top: 8px;
  position: relative;
  .one-game {
    & > div {
      width: 100%;
      height: 100%;
      &.no-empty:hover,
      &.selected-photo {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          border: 1px solid $color-price;
          box-shadow: 0px 0px 8px rgba(216, 121, 1, 0.8);
          border-radius: 4px;
        }
      }
    }
    .game-image,
    .empty-img {
      border-radius: 4px;
      width: 100%;
      height: 100%;
      background: rgba($color: $color-button, $alpha: 0.7);
    }
  }
  .custom-arrow {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.4) !important;
    opacity: 0;
  }
  .custom-arrow-right {
    right: 4px;
  }
  .custom-arrow-left {
    left: 4px;
  }
}
@media screen and (max-width: 599px) {
  .dynamic-detail-one .image-wrap .origin-image {
    .origin-img {
      max-width: 200px;
      max-height: 200px;
    }
    &.is-width,
    &.is-height {
      max-width: 200px;
      max-height: 200px;
    }
  }
  .dynamic-detail-one .img-list .one-img {
    width: 60px;
    height: 60px;
  }
}
</style>
